export default __webpack_public_path__ + "static/media/financial-planning-mobile.0d5f47ef.svg";